//
//
//
//
//
//
//
//

export default {
	name: 'TrendingSearches',
	props: {
		executeSearch: Function,
		setQuery: Function,
	},
	components: {},
	data() {
		return {
			terms: [],
			loaded: false,
			error: false,
		};
	},
	computed: {},
	methods: {
		async getSearchTerms() {

			let url = this.config.trendingSearchEndpoint;
			let params = new URL(document.location).searchParams;
			if(params.has('query')) {
				url += `&currentTerm=${params.get('query')}`;
			}

			fetch(url)
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					this.terms = data.data.items;
					this.loaded = true;
				})
				.catch((error) => {
					this.error = true;
					console.error(error);
				});

		},
		executeTermSearch(term) {
			this.setQuery(term.name);
			this.executeSearch();
		},
	},
	created() {
		this.getSearchTerms();
	},
	mounted() { },
};
